export default "__VITE_ASSET__q_a0wCY4__"